import { render, staticRenderFns } from "./ClientReferalMain.vue?vue&type=template&id=59c28c18"
import script from "./ClientReferalMain.vue?vue&type=script&lang=js"
export * from "./ClientReferalMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports